import { requests } from './http';

//初始化插件
export const douyinInitilize = () => {
  try {
    const script = document.createElement("script");
    script.src = "https://lf1-fe.ecombdstatic.com/obj/ecom-fe-open-public/component/index.js";
    script.async = true;
    document.body.appendChild(script);
  } catch (ee) {
    console.log("douyinInitilize error:" + ee);
  }
}

export const requestToken = (id, name, type, param) => {
  try {
    //不能是异步
    requests({
      url: "/Home/GetDouyinYinXiaoComponentInfo",
      data: { shopId: id },
      success: (json) => {
        if (json.Success) {
          //存储token信息
          localStorage.setItem("douyinComponentTokens_" + id, JSON.stringify(json.Data));
          baseExecute(json.Data, name, "start", param); 
          baseExecute(json.Data, name, type, param); 
        }
      }
    });
  } catch (ee) {
    console.log("requestToken error:" + ee);
  }
}

//获取token
export const douyinComponentLoad = (id, name, type, param) => {
  try {
    //一个店铺有可能有多个抖音号不同的抖音好token有可能不一致
    var token = localStorage.getItem("douyinComponentTokens_" + id) || null;
    if (token == null && token == undefined) {
      requestToken(id, name, type);
      return
    }
    //获取当前时间戳
    var data = JSON.parse(token);
    const timestamp = Math.floor(new Date().getTime() / 1000); //获取时间戳秒级别
    if (data.TokenExpireTime < timestamp) {
      //刷新token
      requestToken(id, name, type, param);
      return
    }
    baseExecute(data, name, "start", param); 
    baseExecute(data, name, type, param);
  } catch (ee) {
    console.log("douyinComponentLoad error:" + ee);
  }
}

//基本类型运行
export const baseExecute = (data, name, type, param) => {
  if (type == "douyinProductPriceComponent") {
    douyinProductPriceComponent(data.Token, name, data.ShopId, param)
  }
  if (type == "douyinYingXiaoComponent") {
    douyinYingXiaoComponent(data.Token, name, data.ShopId)
  }
  if (type == "start") {
    douyinStartComponent(data.Token, name, data.ShopId)
  }

}

//加载抖音启动组件
export const douyinStartComponent = (token, name, shopId) => {
  try {
  
    setTimeout(() => {
      console.log("douyinStartComponent start");
      window.ecopen.start({
        token:token,
        appId:'6925303336539309583',
        shopId:shopId,
        shopName:name,
      });
      console.log("douyinStartComponent end");
    }, 500);

  } catch (ee) {
    console.log("douyinStartComponent error:" + ee);
  }
}


//加载抖音价格力逻辑
export const douyinProductPriceComponent = (token, name, shopId, param) => {
  try {
    
    setTimeout(() => {
      var id = document.getElementById("douyinPrice" + param)
      window.ecopen.bixi(id, {
        componentId: 329,
        token: token,
        appId: "6925303336539309583",
        appName: "店管家铺货助手",
        shopId: shopId,
        shopName: name,
        text: "",
        extra: {
          productId: param
        }
      })
    }, 200);
  } catch (ee) {
    console.log("douyinProductPriceComponent error:" + ee);
  }

}

//加载抖音营销组件
export const douyinYingXiaoComponent = (token, name, shopId) => {
  try {
    //var isInitDouyyinComponentTokens = localStorage.getItem("isInitDouyyinComponentTokens") || null;
    //if (isInitDouyyinComponentTokens != null && isInitDouyyinComponentTokens != undefined) {
    //  const oldDate = new Date(isInitDouyyinComponentTokens);
    //  var newDate = new Date();
   //   if (newDate < oldDate) {
   //     return;
   //   }
   // }

    setTimeout(() => {
      console.log("douyinYingXiaoComponent start");
      //var date = new Date();
      //date.setDate(date.getDate() + 3);
      //localStorage.setItem("isInitDouyyinComponentTokens", date.toLocaleString());
      window.ecopen.bixi(document.body, {
        componentId: 330,
        token: token,
        appId: "6925303336539309583",
        appName: "店管家铺货助手",
        shopId: shopId,
        shopName: name
      });
      console.log("douyinYingXiaoComponent end");
    }, 500);

  } catch (ee) {
    console.log("douyinYingXiaoComponent error:" + ee);
  }
}


// WEBPACK FOOTER //
// ./src/utils/douyinplugin.js